export const OverviewObj = {
    id : 'profile',
    lightBg: false,
    lightText: false,
    lightTextDesc: true,
    imgStart: true,
    img: require('../../images/profilepic.jpg').default,
    darkText: true,
    skillIconSize: '35px',
    starSize: '25px',
    tooltip1: 'Python | >3 Years | Expert Usage | Can build backend applications from scratch using Django or Flask',
    tooltip2: 'Docker | >2 Years | Moderate Usage | Able to create, deploy and manage application containers',
    tooltip3: 'AWS | >2 Years | Moderate Usage | Posses knowledge of services like ECS, EB, S3, EC2, SQS, RDS, Route53, ColudFront etc.',
    tooltip4: 'React | > 4 Months | Beginner Level | Able to build static websites from scratch',
    tooltip5: 'Linux | > 3 Years | Expert Usage | Can use unix terminals to navigate and run commands, can write bash scripts',
    tooltip6: 'GitHub | > 4 Years | Expert Usage | Posses knowledge of various Git functionalities and features',
};

